import { render } from "./SideSportBar.vue?vue&type=template&id=693d7274&scoped=true"
import script from "./SideSportBar.vue?vue&type=script&lang=js"
export * from "./SideSportBar.vue?vue&type=script&lang=js"

import "./SideSportBar.vue?vue&type=style&index=0&id=693d7274&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693d7274"]])

export default __exports__